import React from 'react';
import { DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

type EditReceiptDialogHeaderProps = {
  onClose: () => void;
};

const EditReceiptDialogHeader: React.FC<EditReceiptDialogHeaderProps> = React.memo(({ onClose }) => {
  return (
    <DialogTitle
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#EEE8FF',
        color: '#222B45',
        fontWeight: 'bold',
      }}
    >
      Edit or Replace Receipt Image
      <IconButton onClick={onClose} size="small">
        <Close sx={{ color: '#222B45' }} />
      </IconButton>
    </DialogTitle>
  );
});

EditReceiptDialogHeader.displayName = 'EditReceiptDialogHeader';

export default EditReceiptDialogHeader;
